module.exports = __webpack_public_path__ + "img/kai.25ddc35.webp";